<!-- MODAL cambiarFecha -->
<div mdbModal #cambiarFecha="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <form [formGroup]='formData' novalidate>
      <div class="modal-content" *ngIf="pago">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Nueva fecha de vencimiento
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cambiarFecha.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Cheque #{{pago.numero_doc}}
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <div class="dato">
                  <label class="title">Fecha de Vencimiento actual</label>
                  <span class="value">{{pago.fecha_vencimiento | fecha}}</span>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <div class="dato">
                  <label for="nuevaFechaVencimiento">Nueva Fecha Vencimiento</label>
                  <mdb-date-picker [inline]="true" name="nuevaFecha" [placeholder]="'Nueva fecha de Venc.'" required
                    formControlName="nuevaFechaVencimiento" id="nuevaFechaVencimiento">
                  </mdb-date-picker>
                  <div *ngIf="
                      formData.get('nuevaFechaVencimiento').invalid &&
                      (formData.get('nuevaFechaVencimiento').dirty ||
                      formData.get('nuevaFechaVencimiento').touched)
                  ">
                    <mdb-error *ngIf="formData.get('nuevaFechaVencimiento').hasError('required')">
                      Ingrese nueva fecha Vencimiento
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="observacion" class="form-control" placeholder="" required #observacion
                  formControlName="observacion" />
                <label for="observacion">Observación</label>
                <div *ngIf="
                      formData.get('observacion').invalid &&
                      (formData.get('observacion').dirty ||
                      formData.get('observacion').touched)
                  ">
                  <mdb-error *ngIf="formData.get('observacion').hasError('required')">
                    Ingrese observación
                  </mdb-error>
                  <mdb-error *ngIf="formData.get('observacion').hasError('maxlength')">
                    Largo máximo es de 200 caracteres
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-footer justify-content-between">
          <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
            (click)="cambiarFecha.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <button size="sm" type="button" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
            (click)="cambiarFechaVencimiento()">
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
